// From https://stackoverflow.com/a/37511463/9523553
// Semantic-UI uses the same implementation to ignore diacritics in dropdowns.
// First, converts the string into a two byte string,
// then removes the second bytes when it represents a accent, trema…
// https://fr.wikipedia.org/wiki/Table_des_caractères_Unicode/U0300
export default function removeDiacritics(string?: string) {
  return string ? string.normalize("NFD").replace(/[\u0300-\u036f]/g, "") : "";
}
